import React from "react";
import { string, func, any } from "prop-types";
import { PulseLoader } from "../../common";
import * as style from "./styles.module.scss";
import SearchBox from "../SearchBox";

const BookingsLoading = ({ searchValue, setSearchValue, isLoading }) => {
  return (
    <div>
      <h2>Your Bookings</h2>
      <SearchBox
        value={searchValue}
        onChange={setSearchValue}
        placeholder="Search"
        onCloseClick={() => setSearchValue("")}
        className={style.bookings__searchbox}
        disabled={isLoading}
      />
      <div className="w-100 d-flex flex-column align-items-center justify-content-center mt-xl-4 mt-lg-4 mt-3">
        <PulseLoader />
        <h2 className="mt-2">Collecting your data</h2>
        <b>This won&apos;t take too long</b>
      </div>
    </div>
  );
};

BookingsLoading.propTypes = {
  searchValue: string,
  setSearchValue: func,
  isLoading: any,
};

export default BookingsLoading;
